import { client } from '@/api';

import * as types from '../../mutationTypes';

export default {
  async getAllAppliedUpdates({ commit }) {
    const response = await client.getAllAppliedUpdates();
    commit(types.BULK_ADD_APPLIED_UPDATES, response.data);
  },

  async getAllComplispaceUpdates({ commit }) {
    const response = await client.getAllComplispaceUpdates();
    commit(types.BULK_ADD_COMPLISPACE_PUBLISHED, response.data);
  },

  setPublishAt({ commit }, { publishAt, id }) {
    commit(types.SET_PUBLISH_AT, { publishAt, id });
  }
};
